import { DeviceUUID } from "device-uuid";
import { Observable } from "rxjs";
export var du = new DeviceUUID().parse();
var dua = [
  du.platform,
  du.os,
  du.cpuCores,
  du.isAuthoritative,
  du.silkAccelerated,
  du.isKindleFire,
  du.isDesktop,
  du.isMobile,
  du.isTablet,
  du.isWindows,
  du.isLinux,
  du.isLinux64,
  du.isMac,
  du.isiPad,
  du.isiPhone,
  du.isiPod,
  du.isSmartTV,
  du.pixelDepth,
  du.isTouchScreen
];
export const deviceUuid = du.hashMD5(dua.join(':'));
export const deviceSpecs = JSON.stringify(du);

export function isAppleDevice() : boolean {
  let plat = String(du.platform).toLowerCase();
  return plat.indexOf('apple') != -1 || plat.indexOf('mac') != -1;  
}

export function isAndroidDevice() : boolean {
  let plat = String(du.platform).toLowerCase();
  return plat.indexOf('android') != -1;  
}